import {BaseClient} from "./BaseClient";
import { Result } from "./Result";

export type Granularity = 'PT15S' | 'PT1M' | 'PT5M' | 'PT30M'

export interface MeterApi {
    mpan: string
    description: string
    readingsGranularities: Granularity[]
    hasSiteAttached: boolean
}

export interface MeterWithDeviceApi {
    id: number
    mpan: string
    deviceId?: string
    imageMeterId?: string
}


export class MeterClient {
    baseClient: BaseClient

    constructor(baseClient: BaseClient) {
        this.baseClient = baseClient
    }

    async retrieveMeters(): Promise<MeterApi[]> {
        const ok = this.baseClient.getOk<MeterApi[]>(`/api/meter`);
        return ok;
    }

    async retrieveMetersWithDevices(buildingId: number): Promise<Result<MeterWithDeviceApi[]>> {
        const ok = this.baseClient.getOkP<MeterWithDeviceApi[]>(`/api/meterWithDevice?buildingId=${buildingId}`);
        return ok;
    }
}
